import {inject, Pipe, PipeTransform} from '@angular/core';
import {BackendDateFormats} from '../date-format/date-format';
import {DateFormatService} from '../date-format/date-format.service';

/**
 * Re-shows a date string the backend formatted itself in the company's profile — see
 * `DateFormatService.reformat`. Pure, like `formatDate`: the profile is fixed for a page's lifetime.
 */
@Pipe({
  name: 'reformatDate'
})
export class ReformatDatePipe implements PipeTransform {
  private readonly formats = inject(DateFormatService);

  transform(value: string | null | undefined, formats: BackendDateFormats): string {
    return this.formats.reformat(value, formats);
  }
}
